import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { RootShareRecommendations } from './getShareRecommendations';
import { getShareRecommendations } from './getShareRecommendations';

export type {
	FacebookShareRecommendations,
	RedditShareRecommendations,
	RootShareRecommendations,
} from './getShareRecommendations';

export function useFetchShareRecommendations(slug: string, enabled: boolean): UseQueryResult<RootShareRecommendations> {
	const utilityContext = useUtilityContext();

	return useQuery({
		queryKey: ['share-recommendations', { slug }],
		queryFn: async () => getShareRecommendations(utilityContext, slug),
		enabled,
	});
}
